import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import FakeNotification from '../FakeNotification';
import s from './FakeDrawer.scss';
var FakeDrawer = function (_a) {
    var _b = _a.showBetaLabel, showBetaLabel = _b === void 0 ? true : _b;
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['drawer-header'] },
            React.createElement("div", { className: s['title'] },
                t('siteHeader.anonFakeNotifications.drawer.title'),
                showBetaLabel && React.createElement("span", { className: s['beta'] }, "BETA")),
            React.createElement(PlainButtonOrLink, { href: Url.joinLink(), className: s['see-all'] }, t('siteHeader.anonFakeNotifications.drawer.seeAll'))),
        React.createElement(FakeNotification, null)));
};
FakeDrawer.displayName = 'FakeDrawer';
export default FakeDrawer;
//# sourceMappingURL=FakeDrawer.js.map